import React from 'react'
import Wordmark from './Wordmark'

export interface LegalPageViewProps {
  title: string
  lastUpdated: string
  children: React.ReactNode
}

export default function LegalPageView({
  title,
  lastUpdated,
  children
}: LegalPageViewProps): React.JSX.Element {
  return (
    <main className="published-story-shell legal-page-shell">
      <header className="published-story-header">
        <div className="published-story-header-inner">
          <a href="/home" className="published-story-home" aria-label="Nine Nights home">
            <Wordmark size={24} />
          </a>
        </div>
      </header>
      <article className="legal-page">
        <h1>{title}</h1>
        <p className="legal-page-updated">Last updated: {lastUpdated}</p>
        {children}
      </article>
    </main>
  )
}
